import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import AuthenticateService from "../auth/AuthenticateService";
import { Spinner } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import AuthLayout from "./AuthLayout";

const registerBrandFeatures = [
  { icon: "fa-bolt", text: "Get started in minutes" },
  { icon: "fa-shield-halved", text: "Your data is encrypted end-to-end" },
  { icon: "fa-wallet", text: "One wallet for airtime, bills & transfers" },
];

const Register = (props) => {
  const company = props.company;
  const [showPassword, setShowPassword] = useState(false);

  const [formData, setFormData] = useState({
    username: "",
    password: "",
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    dob: "",
    nin:"",
    pin: "",
    cpassword: "",
    bvn: "",
    company: company != null ? company.company_reference : "",
  });
  const { http, setToken } = AuthenticateService();
  const [isLoging, setIsLoging] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Registration";
  }, []);

  // setFormData({ ...formData, company: company?.company_reference })
  // console.log(formData);

  const [error, setError] = useState("");
  const [logined, setLogined] = useState("");
  const onSubmit = (e) => {
    setError("");
    setFormData({ ...formData, company: company?.company_reference });
    // console.log(company?.company_reference);
    // console.log(formData);
    e.preventDefault();
    setIsLoging(true);

    const emptyFields = Object.entries(formData)
      .filter(([key, value]) => value === "")
      .map(([key]) => key);

    if (emptyFields.length > 0) {
      console.log(emptyFields.length);
      const errorMessage = `${emptyFields.join(" , ")} field${
        emptyFields.length < 2 ? " is" : "(s) are"
      } required`;
      setError(errorMessage);
      setIsLoging(false);
      return; // Return early if validation fails
    }

    // setError('');

    http
      .post("/users/register", formData)

      .then((res) => {
        if (res.data.status === true) {
          setError("");
          navigate("/");
          toast.success(res.data.message);
          setIsLoging(false);
        } else if (res.status === 0) {
          // navigate('/')

          toast.error(res.data.message);
          setIsLoging(false);
        } else {
          toast.error(res.data.message);
          // setError(res.data.message);
          setIsLoging(false);
        }
      })
      .catch((error) => {
        toast.error(error.response.data.message);
        setIsLoging(false);
      });
  };

  return (
    <AuthLayout company={company} wide brandFeatures={registerBrandFeatures}>
      <ToastContainer />
      <div className="auth-heading">
        <h3 className="text-1000">Create your account</h3>
        <p className="text-700">
          Join {company?.company_name || "us"} and start managing your money today
        </p>
      </div>

      {error && (
        <div className="alert alert-outline-danger d-flex align-items-center py-2 mb-3" role="alert">
          <span className="fas fa-circle-exclamation text-danger fs--1 me-2"></span>
          <p className="mb-0 flex-1 fs--1">{error}</p>
        </div>
      )}
      {logined && (
        <div className="alert alert-outline-success d-flex align-items-center py-2 mb-3" role="alert">
          <span className="fas fa-circle-check text-success fs--1 me-2"></span>
          <p className="mb-0 flex-1 fs--1">{logined}</p>
        </div>
      )}

      {company && (
        <form onSubmit={onSubmit}>
          <p className="fs--1 fw-bold text-800 text-uppercase mb-2">Personal Information</p>
          <div className="row">
            <div className="col-md-6 auth-field">
              <label className="form-label" htmlFor="first_name">
                First Name
              </label>
              <div className="form-icon-container">
                <input
                  id="first_name"
                  onChange={(e) =>
                    setFormData({ ...formData, first_name: e.target.value })
                  }
                  className="form-control form-icon-input"
                  type="text"
                  placeholder="Firstname"
                />
                <span className="fas fa-user text-900 fs--1 form-icon"></span>
              </div>
            </div>
            <div className="col-md-6 auth-field">
              <label className="form-label" htmlFor="last_name">
                Last Name
              </label>
              <div className="form-icon-container">
                <input
                  id="last_name"
                  className="form-control form-icon-input"
                  onChange={(e) =>
                    setFormData({ ...formData, last_name: e.target.value })
                  }
                  type="text"
                  placeholder="Lastname"
                />
                <span className="fas fa-user text-900 fs--1 form-icon"></span>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 auth-field">
              <label className="form-label" htmlFor="dob">
                Date of Birth
              </label>
              <div className="form-icon-container">
                <input
                  id="dob"
                  className="form-control form-icon-input"
                  onChange={(e) =>
                    setFormData({ ...formData, dob: e.target.value })
                  }
                  type="date"
                  placeholder="Date Of Birth"
                />
                <span className="fas fa-calendar-days text-900 fs--1 form-icon"></span>
              </div>
            </div>
          </div>

          <p className="fs--1 fw-bold text-800 text-uppercase mb-2 mt-3">Contact Details</p>
          <div className="row">
            <div className="col-md-6 auth-field">
              <label className="form-label" htmlFor="username">
                Username
              </label>
              <div className="form-icon-container">
                <input
                  id="username"
                  className="form-control form-icon-input"
                  onChange={(e) =>
                    setFormData({ ...formData, username: e.target.value })
                  }
                  type="text"
                  placeholder="devvboy001"
                />
                <span className="fas fa-at text-900 fs--1 form-icon"></span>
              </div>
            </div>
            <div className="col-md-6 auth-field">
              <label className="form-label" htmlFor="phone">
                Phone Number
              </label>
              <div className="form-icon-container">
                <input
                  id="phone"
                  className="form-control form-icon-input"
                  onChange={(e) =>
                    setFormData({ ...formData, phone: e.target.value })
                  }
                  type="tel"
                  placeholder="Phone Number"
                />
                <span className="fas fa-phone text-900 fs--1 form-icon"></span>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 auth-field">
              <label className="form-label" htmlFor="email">
                Email
              </label>
              <div className="form-icon-container">
                <input
                  id="email"
                  className="form-control form-icon-input"
                  onChange={(e) =>
                    setFormData({ ...formData, email: e.target.value })
                  }
                  type="email"
                  placeholder="Email"
                />
                <span className="fas fa-envelope text-900 fs--1 form-icon"></span>
              </div>
            </div>
          </div>

          <p className="fs--1 fw-bold text-800 text-uppercase mb-2 mt-3">Identity Verification</p>
          <div className="row">
            <div className="col-md-6 auth-field">
              <label className="form-label" htmlFor="bvn">
                BVN
              </label>
              <div className="form-icon-container">
                <input
                  id="bvn"
                  className="form-control form-icon-input"
                  maxLength={11}
                  onChange={(e) =>
                    setFormData({ ...formData, bvn: e.target.value })
                  }
                  type="number"
                  placeholder="BVN"
                />
                <span className="fas fa-id-card text-900 fs--1 form-icon"></span>
              </div>
            </div>
            <div className="col-md-6 auth-field">
              <label className="form-label" htmlFor="nin">
                National Identity Number
              </label>
              <div className="form-icon-container">
                <input
                  id="nin"
                  className="form-control form-icon-input"
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      nin: e.target.value,
                      company: company?.company_reference,
                    })
                  }
                  type="number"
                  placeholder="National Identity Number"
                />
                <span className="fas fa-id-badge text-900 fs--1 form-icon"></span>
              </div>
            </div>
          </div>

          <p className="fs--1 fw-bold text-800 text-uppercase mb-2 mt-3">Security</p>
          <div className="row">
            <div className="col-md-6 auth-field">
              <label className="form-label" htmlFor="pin">
                Transaction PIN
              </label>
              <div className="form-icon-container">
                <input
                  id="pin"
                  maxLength={4}
                  className="form-control form-icon-input"
                  onChange={(e) =>
                    setFormData({ ...formData, pin: e.target.value })
                  }
                  type="number"
                  placeholder="4-digit PIN"
                />
                <span className="fas fa-lock text-900 fs--1 form-icon"></span>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 auth-field">
              <label className="form-label" htmlFor="password">
                Password
              </label>
              <div className="form-icon-container position-relative">
                <input
                  className="form-control form-icon-input"
                  id="password"
                  onChange={(e) =>
                    setFormData({ ...formData, password: e.target.value })
                  }
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                />
                <span className="fas fa-key text-900 fs--1 form-icon"></span>

                <button
                  type="button"
                  className="auth-toggle-visibility"
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                </button>
              </div>
            </div>
            <div className="col-md-6 auth-field">
              <label className="form-label" htmlFor="confirmPassword">
                Confirm Password
              </label>
              <div className="form-icon-container">
                <input
                  className="form-control form-icon-input"
                  onChange={(e) =>
                    setFormData({ ...formData, cpassword: e.target.value })
                  }
                  id="confirmPassword"
                  type={showPassword ? "text" : "password"}
                  placeholder="Confirm Password"
                />
                <span className="fas fa-key text-900 fs--1 form-icon"></span>
              </div>
            </div>
          </div>

          <div className="form-check mb-3 mt-2">
            <input
              className="form-check-input"
              id="termsService"
              type="checkbox"
            />
            <label
              className="form-label fs--1 text-700 text-none"
              htmlFor="termsService"
            >
              I accept the <a href="sign-up.html#!">terms </a>and{" "}
              <a href="#!">privacy policy</a>
            </label>
          </div>

          <button type="submit" className="btn-auth-primary" disabled={isLoging}>
            {isLoging ? (
              <>
                <Spinner animation="border" size="sm" /> Creating account...
              </>
            ) : (
              <>
                Sign Up <FontAwesomeIcon icon={faArrowRight} className="fs--1" />
              </>
            )}
          </button>

          <div className="text-center mt-4">
            <span className="fs--1 text-700">Already have an account? </span>
            <Link className="fs--1 fw-bold" to="/">
              Sign in
            </Link>
          </div>
        </form>
      )}
    </AuthLayout>
  );
};

export default Register;
